import {NgModule} from '@angular/core';
import {FooterComponent} from './footer.component';
import {RouterModule} from '@angular/router';

@NgModule({
    imports: [RouterModule],
    declarations: [FooterComponent],
    exports: [FooterComponent]
})
export class FooterModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/footer/footer.module.ts